import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useShippingQuote(items, subtotal) {
  const [quote, setQuote] = useState(null);
  const key = items.map((i) => `${i.product_id}:${i.quantity}`).join(",");
  useEffect(() => {
    if (!items.length) return;
    const t = setTimeout(() => {
      api.post("/shipping/quote", { items: items.map((i) => ({ product_id: i.product_id, quantity: i.quantity })), subtotal })
        .then((r) => setQuote(r.data))
        .catch(() => {});
    }, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, subtotal]);
  return quote;
}
